import type { IAuthRepository, LoginInput } from '../repositories/IAuthRepository.js';
import type { AuthSessionEntity } from '../entities/AuthSessionEntity.js';

interface Dependencies {
  authRepository: IAuthRepository;
}

export function createLoginUseCase({ authRepository }: Dependencies) {
  return async function login(input: LoginInput): Promise<AuthSessionEntity> {
    return authRepository.login(input);
  };
}
